import React from "react";
import { NavLink } from "react-router-dom";
import direction from "../../service/direction.json";
const OptionsIncome = () => {
  return (
    <div className="container text-justify" style={{ fontSize: "20px" }}>
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        ویژگی ها و درآمد نمایندگی پنل اس ام اس
      </div>
      <br />
      کار با پنل نمایندگی بسیار آسان است و نیازی به سواد خاص ندارد و کافیست تا
      اندکی مهارت کار با کامپیوتر و اینترنت داشته باشید و اینکه شما وارد سایت ما
      شده اید و تا این صفحه آمده اید نشانگر این است که شما مهارت لازم را دارید.
      برای آشنایی با منو ها و امکانات و نحوه کار با پنل نمایندگی فایل آموزشی را
      دانلود کرده و بخوانید. اما درآمد نمایندگی پنل اس ام اس از کجاست؟ نمایندگان
      پنل پیامک چگونه کسب درآمد میکنند؟
      <br />
      برای نمایندگی شما ملزم به داشتن هاستینگ یا وبسایت نیستید و از امکانات ما
      بصورت رایگان بهره میبرید. فقط با مبلغ تقریبا 5 هزار تومان یک دامنه با نام
      دلخواه خود ثبت میکنید مثل www.example.ir تا آدرس ورود کاربرانتان به سامانه
      را جدا و مشخص کنید. (تمام کارها و تنظیمات مربوطه را ما برایتان انجام
      خواهیم داد)
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        درآمد نمایندگی پنل اس ام اس
      </div>
      نمایندگان سایه بان میتوانند از راه های زیر کسب درآمد کنند:
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        1- فروش پنل پیامک
      </div>
      نمایندگان ما به تعداد نامحدود و بدون پرداخت هیچ هزینه ای میتوانند اکانت
      کاربری بسازند و این پنل یا همان سامانه پیامکی را به هر قیمتی که دوست دارند
      به مشتریان خود بفروشند. سود حاصل از فروش پنل اس ام اس قسمت اعظمی از درآمد
      نمایندگان را شامل میشود. چون مثلا اگر شما هر روز فقط دو پنل به قیمت 100
      هزار تومان بفروشید درآمد شما در ماه فقط از فروش پنل میشود شش میلیون تومان!
      <br />و جالبتر اینکه به هریک از کاربران شما 3 عدد خط اختصاصی کاملا رایگان
      میدهیم که شما در ازای آن از کاربرانتان مبلغ دلخواه را دریافت میکنید. و
      همچنین با تبلیغات بر اساس اعطای 3 خط اختصاصی به کاربران جذابیت فوق العاده
      ای برای فروش پنل و حتی اعطای نمایندگی خواهید داشت چرا که به کاربران
      نمایندگانی که شما اعطا کرده اید نیز 3 خط اختصاصی رایگان خواهیم داد.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        2- درآمد نمایندگی پنل پیامک از فروش خط اختصاصی
      </div>
      اگر کاربرانتان خطی علاوه بر خطوط رایگان نیاز داشته باشند شما میتوانید خطوط
      اضافی را با قیمت مصوب پایین تر از ما تهیه و با قیمت دلخواه به کاربر اعطا
      کنید.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        3- سود حاصل از ارسال پیامک توسط کاربران نمایندگان
      </div>
      همه ی نمایندگان با توجه به نوع پنل با نرخ ثابتی پیامک خریداری میکنند و به
      قیمت دلخواه به کاربرانشان میفروشند و از این راه سود میکنند. مثلا نماینده
      سطح چهار که هر پیامک برایش 95 ریال تمام میشود اگر تعرفه هر پیامک را برای
      کاربرانش 115 ریال تعیین کند از هر پیامک ارسالی کاربرانش 30 ریال سود خواهد
      کرد. پس هرچقدر کاربرانتان بیشتر پیامک ارسال کنند شما هم به همان مقدار
      بیشتر سود خواهید کرد. (نحوه ی تعیین تعرفه برای کاربران در فایل آموزشی
      توضیح داده شده)
      <div className="text-center">
        <img
          src={`${direction.ImgDesign}profit-of-sms-panel-reseller.jpg`}
          alt="سایه بان"
        />
      </div>
      بعد از گذشت چند ماه که تعداد کاربرانتان افزایش یافت، از این راه سود خوبی
      خواهید کرد. حال رفته رفته و بعد از گذشت یکی دو سال، روزانه از خرید شارژ
      کاربرانتان سود بیشتری خواهید کرد! طوری که کافیست در خانه بنشینید و از سود{" "}
      <NavLink to="/Reseller">نمایندگی پنل اس ام اس</NavLink> لذت ببرید…!
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        4- ارسال پیامک تبلیغاتی به دیگران
      </div>
      حتما در بازاریابی در سطح شهر به افرادی بر خواهید خورد که هرچقدر برایشان در
      مورد سامانه پیامکی یا همان پنل ارسال اس ام اس توضیح میدهید متوجه نمیشوند
      که چیست و چطور با آن کار خواهند کرد. این افراد عموما افرادی با سن بالا و
      کم سواد هستند که هیچ ارتباطی با کامپیوتر و اینترنت نداشته اند. ولی بدلیل
      شغل و صنفی که دارند مایل به ارسال پیامک تبلیغاتی (معمولا برای منطقه پستی
      خاص) میباشند. در این مواقع بهتر است شما بجای قانع کردن آنها برای خرید پنل
      آنها را تشویق کنید تا هرچند تا پیامک که میخواهند هزینه اش را به شما بدهند
      و شما از پنل خودتان پیامک ها را ارسال کنید. که اگر تعداد پیامک زیادی
      بخواهند یا به دفعات زیاد سفارش ارسال به شما بکنند سود خوبی خواهد داشت.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        5- در آمد از شرکت در جشنواره های مناسبتی سایه بان
      </div>
      همانطور که میدانید شرکت سایه بان کمترین تعرفه ارسال در کل کشور را دارد و
      کسانی که برای داشتن کسب و کار باصرفه و پرسود دنبال کمترین تعرفه ارسال
      پیامک هستند، مسلما نتایج بررسی آنها به سایه بان منتهی خواهد شد. با اینحال
      شما میتوانید کمتر از این تعرفه را هم از شرکت سایه بان دریافت کنید! میپرسید
      چگونه؟ سامانه پیام کوتاه سایه بان تقریبا ماهانه برای مناسبت های مختلف
      جشنواره های خرید شارژ برگزار میکند و شما میتوانید با شرکت در این جشنواره
      ها و خرید شارژ بصورت یکجا حتی تا 20% اعتبار هدیه بگیرید. یعنی هر پیامک
      برای شما کمتر از 7 تومان تمام میشود!
      <br />
      ضمنا شرکت در این جشنواره ها کاملا اختیاری بوده و هیچ نماینده ای مجبور به
      خرید شارژ بصورت یکجا نیست.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        6- فروش خدمات تلفن ثابت ابری
      </div>
      شرکت سایه بان علاوه خدمات پیامک در حوزه تلفن مجازی اینترنتی نیز خدمات
      ارائه میکند و شما با تهیه نمایندگی پیامک از ما، درواقع نمایندگی فروش خدمات
      تلفن ابری را نیز دارید و میتوانید از ارائه این خدمات به مشتریان و حتی
      ارائه نمایندگی فروش این خدمات نیز کسب درامد خوبی داشته باشید. برای اطلاعات
      بیشتر در این خصوص لطفا برگه{" "}
      <NavLink to="/VOPInfo">تلفن ثابت ابری</NavLink> سایه بان را بخوانید.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        7- تمدید پنل و خط برای مشتریان در سال های دوم به بعد
      </div>
      پنل نمایندگی که سایه بان به شما ارائه میکند، دائمی و بدون نیاز به تمدید
      است. ولی شما این اختیار را دارید که برای کاربران خود پنل ها را بصورت
      سالانه تعریف کنید که بعد از گذشت یکسال دوباره باید تمدید شوند. بعلاوه شما
      میتوانید به ازای دریافت مبلغ دلخواه از کاربرانتان پنل آنها را تمدید کنید و
      این مانند اینست که تمام مشتریانی که سال اول پیدا کرده بودید را بدون زحمت و
      بدون بازاریابی دوباره در سال های بعد از آنها پول بگیرید و پنل بدهید.
      <br />
      همچنین با اینکه سامانه پیام کوتاه سایه بان خطوط اختصاصی را بصورت دائمی در
      اختیار نمایندگان خود قرار میدهد، نمایندگان میتوانند این خطوط اختصاصی را به
      کاربران یا نمایندگان خود به صورت یکساله تعریف کنند و هزینه ی سالانه از
      آنها دریافت نمایند.
      <br />
      <div className="text-bold " style={{ fontSize: "32px" }}>
        8- اعطای نمایندگی پنل پیامک ippanel
      </div>
      شما نیز میتوانید به تعداد نامحدود بدون هزینه نمایندگی مستقل اعطا کنید و در
      ازای آن از نماینده خود مبلغ دلخواه دریافت کنید و قیمت پیامک و خطوط را نیز
      برای او تعیین کنید و از فروش خطوط و ارسالهای کاربران وی نیز سود کنید.
      <br />
      اگر هرگونه سوالی داشتید:
      <ol>
        <li>در صورت آنلاین بودن با پشتیبان گفتگو کنید.</li>
        <li>
          به sayyehban@gmail.com ایمیل بزنید. (ایمیل های ما هرروز به دفعات چک
          میشوند)
        </li>
        <li>با شماره تلفن 02165626933 تماس بگیرید.</li>
      </ol>
    </div>
  );
};

export default OptionsIncome;
